export const mockLeaderboard = [
  {
    rank: 1,
    name: "Sarah Kim",
    handle: "@sarahkimfinds",
    platform: "TikTok",
    platformIcon: "ri-tiktok-line",
    country: "USA",
    avatar: "https://public.readdy.ai/ai/img_res/5eb051b1d6a6cd51205a960233d6f7c7.jpg",
    followers: "2.4M",
    salesThisMonth: 892,
    commissionThisMonth: 18640,
    totalCommission: 142800,
    topProduct: "Raw Wildflower Honey 32oz",
    badge: "🏆 #1 Top Earner",
    tier: "Diamond",
    growth: "+34%",
  },
  {
    rank: 2,
    name: "Marcus Johnson",
    handle: "@marcusoutdoors",
    platform: "YouTube",
    platformIcon: "ri-youtube-line",
    country: "Canada",
    avatar: "https://readdy.ai/api/search-image?query=young%20black%20man%20outdoor%20lifestyle%20youtuber%20smiling%20confidently%2C%20bright%20studio%20background%2C%20casual%20outdoor%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20content%20creator&width=100&height=100&seq=lb2&orientation=squarish",
    followers: "1.8M",
    salesThisMonth: 741,
    commissionThisMonth: 15320,
    totalCommission: 98400,
    topProduct: "Steel Raised Garden Bed Kit",
    badge: "🥈 #2",
    tier: "Diamond",
    growth: "+28%",
  },
  {
    rank: 3,
    name: "Li Wei (李薇)",
    handle: "@liwei_lifestyle",
    platform: "Douyin",
    platformIcon: "ri-tiktok-line",
    country: "USA",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20woman%20lifestyle%20influencer%20smiling%20confidently%2C%20bright%20studio%20background%2C%20elegant%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20douyin%20content%20creator&width=100&height=100&seq=lb3&orientation=squarish",
    followers: "5.1M",
    salesThisMonth: 698,
    commissionThisMonth: 14210,
    totalCommission: 87600,
    topProduct: "Pure Maple Syrup Gift Set",
    badge: "🥉 #3",
    tier: "Diamond",
    growth: "+41%",
  },
  {
    rank: 4,
    name: "Jessica Chen",
    handle: "@jessicafinds",
    platform: "TikTok",
    platformIcon: "ri-tiktok-line",
    country: "USA",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20woman%20influencer%20smiling%20confidently%2C%20bright%20studio%20background%2C%20fashionable%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20lifestyle%20blogger%20look&width=100&height=100&seq=lb4&orientation=squarish",
    followers: "980K",
    salesThisMonth: 614,
    commissionThisMonth: 12840,
    totalCommission: 74200,
    topProduct: "Texas Hand-Stitched Leather Wallet",
    badge: "⭐ Top 5",
    tier: "Gold",
    growth: "+22%",
    isCurrentUser: true,
  },
  {
    rank: 5,
    name: "Wang Fang (王芳)",
    handle: "@wangfang_美食",
    platform: "WeChat",
    platformIcon: "ri-wechat-line",
    country: "Canada",
    avatar: "https://readdy.ai/api/search-image?query=middle%20aged%20chinese%20woman%20food%20blogger%20smiling%20warmly%2C%20bright%20kitchen%20background%2C%20casual%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20wechat%20content%20creator&width=100&height=100&seq=lb5&orientation=squarish",
    followers: "3.2M",
    salesThisMonth: 587,
    commissionThisMonth: 11940,
    totalCommission: 68900,
    topProduct: "Organic Clover Honey 5lb",
    badge: "⭐ Top 5",
    tier: "Gold",
    growth: "+19%",
  },
  {
    rank: 6,
    name: "Tyler Brooks",
    handle: "@tylerbrooks_garden",
    platform: "Instagram",
    platformIcon: "ri-instagram-line",
    country: "USA",
    avatar: "https://readdy.ai/api/search-image?query=young%20white%20man%20garden%20lifestyle%20influencer%20smiling%20confidently%2C%20bright%20outdoor%20background%2C%20casual%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20instagram%20content%20creator&width=100&height=100&seq=lb6&orientation=squarish",
    followers: "720K",
    salesThisMonth: 521,
    commissionThisMonth: 10420,
    totalCommission: 52100,
    topProduct: "Professional Pruning Shears",
    badge: null,
    tier: "Gold",
    growth: "+15%",
  },
  {
    rank: 7,
    name: "Aisha Patel",
    handle: "@aishacooks",
    platform: "YouTube",
    platformIcon: "ri-youtube-line",
    country: "Canada",
    avatar: "https://readdy.ai/api/search-image?query=young%20south%20asian%20woman%20food%20youtuber%20smiling%20confidently%2C%20bright%20kitchen%20background%2C%20colorful%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20cooking%20content%20creator&width=100&height=100&seq=lb7&orientation=squarish",
    followers: "1.1M",
    salesThisMonth: 489,
    commissionThisMonth: 9780,
    totalCommission: 44300,
    topProduct: "Cold-Pressed Olive Oil 1 Gallon",
    badge: null,
    tier: "Gold",
    growth: "+12%",
  },
  {
    rank: 8,
    name: "Zhang Wei (张伟)",
    handle: "@zhangwei_好物",
    platform: "Douyin",
    platformIcon: "ri-tiktok-line",
    country: "USA",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20man%20lifestyle%20influencer%20smiling%20confidently%2C%20bright%20studio%20background%2C%20trendy%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20douyin%20male%20content%20creator&width=100&height=100&seq=lb8&orientation=squarish",
    followers: "4.8M",
    salesThisMonth: 456,
    commissionThisMonth: 9120,
    totalCommission: 38700,
    topProduct: "Stainless Steel Tumbler 40oz",
    badge: null,
    tier: "Silver",
    growth: "+38%",
  },
  {
    rank: 9,
    name: "Emma Wilson",
    handle: "@emmawilson_home",
    platform: "Instagram",
    platformIcon: "ri-instagram-line",
    country: "USA",
    avatar: "https://readdy.ai/api/search-image?query=young%20white%20woman%20home%20decor%20influencer%20smiling%20confidently%2C%20bright%20home%20interior%20background%2C%20stylish%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20instagram%20home%20decor%20creator&width=100&height=100&seq=lb9&orientation=squarish",
    followers: "540K",
    salesThisMonth: 412,
    commissionThisMonth: 8240,
    totalCommission: 31200,
    topProduct: "Soy Candle Set Cedar Pine",
    badge: null,
    tier: "Silver",
    growth: "+9%",
  },
  {
    rank: 10,
    name: "Carlos Rivera",
    handle: "@carlosrivera_farm",
    platform: "TikTok",
    platformIcon: "ri-tiktok-line",
    country: "Canada",
    avatar: "https://readdy.ai/api/search-image?query=young%20hispanic%20man%20farm%20lifestyle%20influencer%20smiling%20confidently%2C%20bright%20outdoor%20background%2C%20casual%20farm%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20tiktok%20content%20creator&width=100&height=100&seq=lb10&orientation=squarish",
    followers: "390K",
    salesThisMonth: 378,
    commissionThisMonth: 7560,
    totalCommission: 24800,
    topProduct: "Dried Lavender Bundles 12-Pack",
    badge: null,
    tier: "Silver",
    growth: "+27%",
  },
];

export const mockLeaderboardStats = {
  totalResellers: 1284,
  totalCommissionPaidThisMonth: 284600,
  topEarnerThisMonth: 18640,
  avgCommissionPerReseller: 4200,
  newResellersThisMonth: 87,
};

export const tierColors: Record<string, { bg: string; text: string; border: string }> = {
  Diamond: { bg: "bg-[#e8f4fd]", text: "text-[#1a6fa8]", border: "border-[#1a6fa8]/30" },
  Gold: { bg: "bg-[#fdf8f0]", text: "text-[#B8860B]", border: "border-[#D4AF37]/40" },
  Silver: { bg: "bg-gray-100", text: "text-gray-600", border: "border-gray-300" },
};
